import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "progress-bar" }
const _hoisted_2 = {
  key: 0,
  class: "amount-indicator-wrapper"
}
const _hoisted_3 = { class: "total" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Order Amount", -1)
const _hoisted_5 = { class: "remaining" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Remaining", -1)
const _hoisted_7 = {
  key: 1,
  class: "progress-wrapper"
}
const _hoisted_8 = {
  key: 2,
  class: "payment-in-progress"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Payment in progress", -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.order.remaining.amount!=_ctx.order.total.amount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, "$" + _toDisplayString((_ctx.order.total.amount/100).toFixed(2)), 1),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", null, "$" + _toDisplayString((_ctx.order.remaining.amount/100).toFixed(2)), 1),
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.order.remaining.amount!=_ctx.order.total.amount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "progress",
            style: _normalizeStyle(_ctx.progress)
          }, null, 4)
        ]))
      : _createCommentVNode("", true),
    (_ctx.order.remaining.amount==0&&_ctx.order.pending.amount>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true)
  ]))
}